import React, { useContext, useEffect, useState, useCallback } from "react";
import "./styles/TableListFile.scss";
import AppContext from "../../../context/appContext";
import UserContext from "../../../context/userContext";
import TableLoading from "../../../components/TableLoading/TableLoading";
import ListCount from "../../../components/ListCount/ListCount";
import SimpleScriptBox from "../SimpleScriptBox/SimpleScriptBox";
import _ from "lodash";
import ProjectSheetAttachmentsTable from "./ProjectSheetAttachmentsTable/ProjectSheetAttachmentsTable";
import AttachmentsContext from "../../../context/attachmentsContext";
import SingleReleaseTextsModal from "./SingleReleaseTextsModal/SingleReleaseTextsModal";

const TableListFiles = (props) => {
  const {
    handleEditFile,
    data,
    loading,
    handleConfirmationDeleteFile,
    havePermission,
    condition,
    type,
    projectType,
    reload,
    isExternal,
    downloadContext,
    selectedFiles = [],
    setSelectedFiles = () => {},
    isSelectionMode = false,
    canDelete,
    getDeleteUnavailableMessage,
    canReleaseChannel,
    canUnReleaseChannel,
    getReleaseUnavailableMessage,
    getUnReleaseUnavailableMessage,
    canDownload,
    contentId,
  } = props;

  const [state, setState] = useState(false);
  const [stateListFiles, setStateListFiles] = useState([]);

  const [stateOpen, setStateOpen] = useState(false);
  const [stateCurrent, setStateCurrent] = useState(false);

  const [colapsedItems, setColapsedItems] = useState([]);

  const attachmentContext = useContext(AttachmentsContext);
  const appContext = useContext(AppContext);
  const userContext = useContext(UserContext);

  const haveExternalPermission = userContext.hasPermission({
    required: ["ExternalProject"],
  });

  const compileFiles = useCallback(() => {
    let allGroup = attachmentContext.compileAll(data, condition);
    const filteredAllGroup = Object.fromEntries(
      Object.entries(allGroup).map(([key, files]) => [
        key,
        files.filter((file) => file.fileId && file.fileName),
      ])
    );
    let chapterCompiled = attachmentContext.compiledChapter(
      data,
      type,
      condition
    );
    let materialCompiled = attachmentContext.compileMaterial(
      data,
      "Material Complementar"
    );
    let mergeGroups = {
      ...filteredAllGroup,
      ...materialCompiled,
      ...chapterCompiled,
    };

    const mergeObj = Object.entries(mergeGroups).map((files) => files[1]);

    setStateListFiles(mergeObj?.filter((item) => item?.[0]?.type?.id !== 1211));
  }, [attachmentContext, data, type, condition]);

  const toggleGroupList = (group) => {
    setColapsedItems((prevState) => {
      const includesGroup = prevState.includes(group);

      return includesGroup
        ? prevState.filter((item) => item !== group)
        : [...prevState, group];
    });
  };

  const returnColor = (count) => (!!count ? "#7f808e" : "#ec1045");

  const handleOpenReleaseTexts = (currentAttachment, versions) => {
    let copyCurrent = _.cloneDeep(currentAttachment);
    setStateOpen(true);
    setStateCurrent({
      current: copyCurrent,
      versions,
    });
  };

  const compileFilesForChannels = useCallback((filesArray) => {
    const itemsWithType = filesArray.map((item) => ({
      ...item,
      type: item?.type?.name,
    }));
    const groupedByType = _.groupBy(itemsWithType, "type");
    const groupedByTypeOrdered = Object.fromEntries(
      Object.entries(groupedByType).sort((a, b) => {
        return a[0].toLowerCase() > b[0].toLowerCase() ? -1 : 1;
      })
    );
    const groupedByTypeEntries = Object.entries(groupedByTypeOrdered);
    const groupedAndOrdered = groupedByTypeEntries.map((item) =>
      item[1].sort((a, b) => {
        return a.fileName.toLowerCase() > b.fileName.toLowerCase() ? 1 : -1;
      })
    );
    setStateListFiles(groupedAndOrdered.flat(1));
  }, []);

  useEffect(() => {
    if (haveExternalPermission) compileFilesForChannels(data);
    if (!haveExternalPermission) compileFiles();
  }, [haveExternalPermission, compileFilesForChannels, compileFiles, data]);

  const toggleSelectFile = (file, event) => {
    if (!isSelectionMode) return;

    const isAlreadySelected = selectedFiles.some(
      (f) => f.fileId === file.fileId
    );

    if (isAlreadySelected) {
      setSelectedFiles(selectedFiles.filter((f) => f.fileId !== file.fileId));
    } else {
      setSelectedFiles([...selectedFiles, file]);
    }
  };

  const isFileSelected = (fileId) =>
    selectedFiles.some((f) => f.fileId === fileId);

  const handleToggleSelectAll = () => {
    if (!isSelectionMode) return;

    const allFiles = stateListFiles.flatMap((group) => group);
    if (!allFiles.length) return;

    const allSelected = allFiles.every((file) =>
      selectedFiles.some((f) => f.fileId === file.fileId)
    );

    if (allSelected) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(allFiles);
    }
  };

  const areAllSelected = () => {
    if (!stateListFiles?.length) return false;

    const allFiles = stateListFiles.flatMap((group) => group);
    if (!allFiles.length) return false;

    return allFiles.every((file) =>
      selectedFiles.some((f) => f.fileId === file.fileId)
    );
  };

  const totalFilesCount = stateListFiles.reduce(
    (acc, group) => acc + group.length,
    0
  );

  return (
    <section id="TableListFiles">
      <div className="filesListCounter">
        <ListCount
          total={totalFilesCount}
          text={`${
            totalFilesCount > 1 ? "Anexos encontrados" : "Anexo encontrado"
          }`}
        />
      </div>

      <div className="tableContainer">
        {loading ? (
          <TableLoading />
        ) : (
          stateListFiles.length > 0 && (
            <ProjectSheetAttachmentsTable
              data={stateListFiles}
              haveExternalPermission={haveExternalPermission}
              isExternal={isExternal}
              condition={condition}
              type={type}
              havePermission={havePermission}
              isSelectionMode={isSelectionMode}
              isFileSelected={isFileSelected}
              toggleSelectFile={toggleSelectFile}
              areAllSelected={areAllSelected}
              handleToggleSelectAll={handleToggleSelectAll}
              loading={loading}
              handleEditFile={handleEditFile}
              handleConfirmationDeleteFile={handleConfirmationDeleteFile}
              handleOpenReleaseTexts={handleOpenReleaseTexts}
              returnColor={returnColor}
              downloadContext={downloadContext}
              canDelete={canDelete}
              getDeleteUnavailableMessage={getDeleteUnavailableMessage}
              canReleaseChannel={canReleaseChannel}
              canUnReleaseChannel={canUnReleaseChannel}
              getReleaseUnavailableMessage={getReleaseUnavailableMessage}
              getUnReleaseUnavailableMessage={getUnReleaseUnavailableMessage}
              canDownload={canDownload}
              colapsedItems={colapsedItems}
              toggleGroupList={toggleGroupList}
            />
          )
        )}
      </div>

      {state && (
        <SimpleScriptBox open={state} toggleScriptBox={() => setState(false)}>
          <div onClick="">SIM</div>
          <div onClick="">NÃO</div>
        </SimpleScriptBox>
      )}

      {stateOpen && (
        <SingleReleaseTextsModal
          releaseTexts={stateCurrent}
          setStateOpen={setStateOpen}
          reload={reload}
          projectType={projectType}
          submitCallback={() => appContext.setCurrentStepBox("editAttachment")}
          contentId={contentId}
        />
      )}
    </section>
  );
};

export default TableListFiles;
